/**
 * Basic skeleton loader component
 *
 * @param {string=} css- CSS class to be added to the loader (default: "my-2")
 * @param {string=} width - Width of the loader (default: 100%)
 * @param {string=} maxWidth - Max Width of the loader (null by default)
 * @param {string=} height - Height of the loader (default: 35px)
 */

interface SkeletonLoaderProps {
  css?: string;
  width?: number | string;
  maxWidth?: string | null | number;
  height?: number | string;
}

const SkeletonLoader = ({
  css = "my-2",
  width = "100%",
  maxWidth = null,
  height = 35,
}: SkeletonLoaderProps) => {
  return (
    <div
      className={"skeleton " + css}
      style={{ width: width, height: height, ...(maxWidth && { maxWidth }) }}
    ></div>
  );
};

export default SkeletonLoader;
